import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaBlog, FaBookOpen, FaExternalLinkAlt, FaCheckCircle } from 'react-icons/fa';

const highlights = [
  'GitHub Profile Link',
  'Open Source Projects',
  'Developer Articles',
];

const contributions = [
  {
    title: 'GitHub',
    description: 'Public repositories and backend-focused implementations covering Laravel architecture and reusable engineering patterns.',
    url: 'https://github.com/shalender8928/',
    icon: FaGithub,
  },
  {
    title: 'Coding Help Solutions Blog',
    description: 'Technical articles focused on Laravel, PHP, and practical development workflows used in real client projects.',
    url: 'https://codinghelpsolutions.com',
    icon: FaBlog,
  },
  {
    title: 'Developer Tutorials',
    description: 'Step-by-step tutorials and implementation guides that help developers solve production-level backend challenges.',
    url: 'https://codinghelpsolutions.com',
    icon: FaBookOpen,
  },
];

const OpenSourceV2 = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="w-full rounded-2xl bg-white border border-gray-200 p-6 md:p-8">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 tracking-tight text-gray-900">
          Open Source &amp; Developer Contributions
        </h2>
        <div className="w-16 h-1 bg-blue-600 rounded mt-2 mb-6"></div>

        <div className="flex flex-wrap gap-3 mb-8">
          {highlights.map((item) => (
            <span
              key={item}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 text-blue-800 text-sm font-semibold"
            >
              <FaCheckCircle className="text-blue-600" />
              {item}
            </span>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {contributions.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.article
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, delay: index * 0.08 }}
                viewport={{ once: true }}
                whileHover={{ y: -8 }}
                className="rounded-xl bg-gray-50 border border-gray-200 p-6 md:p-8 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-300 space-y-3"
              >
                <div className="w-12 h-12 rounded-lg bg-white shadow-sm flex items-center justify-center mb-4">
                  <Icon className="text-xl text-blue-600" />
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">{item.title}</h3>
                <p className="max-w-prose text-sm md:text-base text-gray-600 leading-relaxed mb-4">{item.description}</p>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 text-sm font-semibold"
                >
                  Visit Link
                  <FaExternalLinkAlt className="text-xs" />
                </a>
              </motion.article>
            );
          })}
        </div>
      </div>
      </div>
    </section>
  );
};

export default OpenSourceV2;
